import { useState } from 'react'

import { GetTaskConfigurationFilesDocument } from 'generated/resources/graphql'
import isNil from 'lodash/isNil'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useFiles = (taskConfigurationId?: number) => {
  const { data, loading } = useQuery(GetTaskConfigurationFilesDocument, {
    skip: isNil(taskConfigurationId),
    variables: {
      taskConfigurationId: taskConfigurationId!,
    },
  })

  const [filesToAdd, setFilesToAdd] = useState<File[]>([])
  const [filesToRemove, setFilesToRemove] = useState(new Set<number>())

  const currentFiles = data?.processes.taskConfigurationFiles

  const onAddFiles = (files: File[]) => {
    setFilesToAdd(filesToAdd.concat(files))
  }

  const onDeleteNewFile = (fileToDelete: File) => {
    setFilesToAdd(filesToAdd.filter((file) => file !== fileToDelete))
  }

  const onDeleteExistingFile = (file: { id: number }) => {
    setFilesToRemove(new Set<number>([...filesToRemove, file.id]))
  }

  return {
    loadingFiles: loading,
    currentFiles,
    filesToAdd,
    filesToRemove,
    onAddFiles,
    onDeleteNewFile,
    onDeleteExistingFile,
  }
}
